module.exports = __webpack_public_path__ + "static/media/undefined.32f51c38.png";